<template>
    <div class="form-template fh">
      <div class="setting-header v-center space-between px-3">
      <div class="setting-heading-box">
          <img class="btn-icon setting-icon" src="~@/assets/images/icons/form-icon.svg" alt="" width="15px" />
        <h1 class="setting-name">
          Form Template
        </h1>
        <p class="setting-subscript">Configurable forms used for data capture and workflows</p>
      </div>
        <div class="v-center">
          <div>
            <label for="">Sort By</label>
            <select v-model="selectedSort" class="sort" name="" id="">
              <option value="1">Latest</option>
              <option value="2">Oldest</option>
              <option value="3">Sort: A to Z</option>
              <option value="4">Sort: Z to A</option>
            </select>
          </div>
          <div class="input-group search m mx-3">
            <input
              v-model="searchKeyword"
              @input="onSearchInput"
              type="text"
              placeholder="Search by name"
            />
          </div>
          <button v-if="showLInkToWorkFlows" class="btn btn-black mr-2" @click="enableWorkflowLink">Link Workflows</button>
          <button v-if="showLinkTemplateButton" class="btn mr-2 btn-cancel " @click="workflowLinkEdit=false">Cancel</button>
          <button v-if="showLinkTemplateButton" class="btn mr-2" @click="linkWorkFlow">Save</button>
          <router-link to="/form-builder" class="btn flex"  v-if="user.tenantLevelRole === 'ADMIN'">
            <button v-if="createNewTemplate" class="btn">+ Add Template</button>
          </router-link>
        </div>
      </div>
      <div class="form-template-container pt-2">
        <div class="fh center" v-if="loading">
          <loading-circle />
        </div>
        <div
          class="form-template-no-form fh center"
          v-if="!loading && templates.length === 0"
        >
          No Form Templates
        </div>
        <div
          :class="{
            fh: true,
            'form-template-split-view': selectedTemplate.open,
          }"
          style="align-items: flex-start"
          v-if="!loading && templates.length"
        >
        <div class="fh">
          <div class="copy-dtx-table form-template-table"
          :style="{
      overflowY: templates.length < 7 ? 'visible' : 'auto'
    }">
      <table >
          <thead>
        <tr class="m">
          <th>Name</th>
          <th>Type</th>
          <th>Created</th>
          <th>Workflow Template</th>
          <th  v-if="showFormAction">Action</th>
        </tr>
      </thead>
        <tbody>
          <tr  v-for="( item, index) in templates" :key="item.id">
          <td v-overflow-tooltip class="elipsis-text ">{{ item.name }}</td>
          <td v-overflow-tooltip class="elipsis-text ">{{ item.core_form_type.name }}</td>
          <td class="audit-cell">
            <span class="audit-name" v-overflow-tooltip>{{  getFullName(item.template_created_by) }}</span>
            <span class="audit-date">{{ item.created_on | genericFormatDate }}</span>
          </td>
          <td>
  <div v-if="workflowLinkEdit">
    <custom-dropdown v-if="item.form_type !== Config.FORM_TEMPLATE_TYPE.JOF && item.form_type !== Config.FORM_TEMPLATE_TYPE.SMF && item.form_type !== Config.FORM_TEMPLATE_TYPE.SBF" :list="workflowTempaltesFiltered" :selected="item.workFlowLinkTemp" @select="(WFT)=>handleWrokflowSelection(WFT,item, index)" @toggle="toggleDropDown(item)" @deselect="()=>handleWrokflowSelection({},item, index)" class="form-template-container-wft">
    <template #before-items>
      <div class="fh center py-4" v-if="WFTLoading && workflowTempaltes.length === 0"  >
            <loading-circle />
          </div>
      <div class="fh center p-3 form-template-container-wft-search-box" v-else  >
          <input type="text" class="custom-dropdown-search" v-model="WFTSearchKeyword"   placeholder="Search"/>
          </div>
    </template>
    </custom-dropdown>
    <custom-dropdown v-else :disabled="true" v-tooltip="'Workflow cannot be linked to Std BOM/Material form'" :list="workflowTempaltesFiltered" :selected="item.workFlowLinkTemp" @select="(WFT)=>handleWrokflowSelection(WFT,item, index)" @toggle="toggleDropDown(item)" @deselect="()=>handleWrokflowSelection({},item, index)" class="form-template-container-wft">
    <template #before-items>
      <div class="fh center py-4" v-if="WFTLoading && workflowTempaltes.length === 0"  >
            <loading-circle />
          </div>
      <div class="fh center py-4" v-else-if="!WFTLoading && workflowTempaltes.length === 0"  >
           No Workflow Templates
          </div>
      <div class="fh center p-3 form-template-container-wft-search-box" v-else  >
          <input type="text" class="custom-dropdown-search" v-model="WFTSearchKeyword"   placeholder="Search"/>
          </div>
    </template>
    </custom-dropdown>
  </div>
  <div v-else  v-overflow-tooltip class="w-100 elipsis-text ">
  {{item.workflow_template?.name ?? '--'}}
  </div>
          </td>
         <td v-if="showFormAction" class="action-column">
          <div class="action-icons">
              <img
                v-if="user.tenantLevelRole === 'ADMIN'"
                width="24"
                v-tooltip="`Edit Template`"
                class="pointer"
                src="~@/assets/images/pencil.svg"
                @click="
                        $router.push(
                          `/form-editor/${item.id}`
                        )
                "
                alt="" />
                <img
                class="ml-2"
                  width="24"
                  v-tooltip="`Preview Template`"
                  src="~@/assets/images/icons/preview-icon.svg"
                  alt=""
                  @click="openPreview(item.id)"
                />
            </div>
         </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="space-between">
      <pagination2 :length="totalcount" :pageNumber="pageNumber" :perPage="perPage"
            @selectPage="selectPage"
          class="mt-3 mx-2"
        />
        <span class="mt-5">Total form templates : &nbsp; <b class="mr-5"> {{ totalcount }}</b></span>
    </div>
        </div>
        <div class="form-template-preview fh" v-if="selectedTemplate.open">
          <div class="form-template-preview-header v-center space-between">
            <div v-if="!selectedTemplate.loading" class="form-template-preview-header-left v-center">
              <h3 v-overflow-tooltip class="form-template-name">{{ selectedTemplate.type }}</h3>
              <span class="status status-preview ml-2">Form Preview</span>
            </div>
            <div v-if="!selectedTemplate.loading" class="v-center">
              <select @change="changeVersion" v-model="selectedTemplate.version">
                <option
                  v-for="version in selectedTemplate.data"
                  :key="version.id"
                  :value="version.id"
                >
                  V-{{ version.version_id }} ({{
                    version.active ? "Latest" : ""
                  }})
                </option>
              </select>
              <button class="close-btn ml-4" @click="closePreview">×</button>
            </div>
          </div>
          <transition name="slide-right" mode="out-in">
            <div v-if="!selectedTemplate.loading" class="form-template-preview-body" key="content">
              <form-preview
                :formName="selectedTemplate.name"
                :formTemplateBody="getSelectedVersionItems"
                :formType="selectedTemplate.type"
                :loading="selectedTemplate.loading"
              />
            </div>
            <div v-else class="form-template-preview-body fh center" key="loading">
              <loading-circle />
            </div>
          </transition>
        </div>
        </div>
      </div>
    </div>
  </template>

<script>
import { mapGetters } from 'vuex'
import { genericFormatDate } from '@/utils/date'
import { getFormTemplateswithPagination, getDetailFormTemplate, getFullWorkFLowTemplates, formWorkFlowLinkingApi } from '@/api'
import loadingCircle from '../../components/common/loadingCircle.vue'
import { timeStampToDateTime } from '@/filters/dateFilter.js'
import FormPreview from '../../components/form/formPreview.vue'
import Config from '@/config'
import customDropdown from '@/components/common/customDropdown.vue'
import { alert, success } from '@/plugins/notification'
import Pagination2 from '@/components/common/pagination2.vue'
import { debounce } from '@/utils/debounce'
import { previousPath } from '@/router'
export default {
  components: { loadingCircle, FormPreview, customDropdown, Pagination2 },
  name: 'form-template',
  filters: {
    timeStampToDateTime,
    genericFormatDate
  },
  data: () => ({
    selectedSort: '1',
    perPage: 10,
    pageNumber: 1,
    totalcount: 0,
    updateOnSearch: null,
    templates: [],
    loading: false,
    searchKeyword: '',
    selectedTemplate: {
      id: 0,
      open: false,
      loading: false,
      data: [],
      name: '',
      type: '',
      version: 0
    },
    Config: Config,
    workflowLinkEdit: false,
    workflowTempaltes: [],
    workflowLinkMap: {},
    WFTLoading: false,
    WFTSearchKeyword: '',
    formType: null
  }),
  computed: {
    ...mapGetters(['user', 'getUserById']),
    ...mapGetters('form', ['searchKeywordStore']),
    getSelectedVersionItems () {
      const version = this.selectedTemplate.data.find(
        (item) => item.id === this.selectedTemplate.version
      ) ?? { template_fields: [] }
      return version.template_fields
    },
    createNewTemplate () {
      return (
        (this.user.tenantLevelRole === 'ADMIN' ||
            this.user.tenantLevelRole === 'COLLABORATOR') && !this.workflowLinkEdit
      )
    },
    showLInkToWorkFlows () {
      return (
        this.user.tenantLevelRole === 'ADMIN' && !this.workflowLinkEdit
      )
    },
    showFormAction () {
      return (
        (this.user.tenantLevelRole === 'ADMIN' ||
            this.user.tenantLevelRole === 'COLLABORATOR' ||
            this.user.tenantLevelRole === 'EDITOR') && !this.workflowLinkEdit
      )
    },
    showLinkTemplateButton () {
      return (
        (this.user.tenantLevelRole === 'ADMIN' ||
            this.user.tenantLevelRole === 'COLLABORATOR' ||
            this.user.tenantLevelRole === 'EDITOR') && this.workflowLinkEdit
      )
    },
    workflowTempaltesFiltered () {
      let templates = this.workflowTempaltes
      const lowerCaseSearch = this.WFTSearchKeyword.toLowerCase()
      if (lowerCaseSearch) {
        templates = templates.filter(t =>
          t.name.toLowerCase().includes(lowerCaseSearch)
        )
      }
      if (this.formType === this.Config.DOCUMENT_REVISIONING_FORM.form_type) {
        templates = templates.filter(t => t.feature_id === this.Config.CORE_FEATURES.DOCUMENTS)
      } else {
        templates = templates.filter(t => t.feature_id !== this.Config.CORE_FEATURES.DOCUMENTS)
      }
      return templates
    }
  },
  methods: {
    toggleDropDown (template) {
      this.WFTSearchKeyword = ''
      this.formType = template.form_type
    },
    onSearchInput () {
      this.$store.dispatch('form/saveSearchKeyword', this.searchKeyword)
      this.updateOnSearch()
    },
    async getTemplates () {
      this.loading = true
      try {
        // true -- // this arguement true is for to avoid standard Material form
        const res = await getFormTemplateswithPagination((this.pageNumber - 1) * this.perPage, this.perPage, true, this.searchKeyword, this.selectedSort)
        this.templates = res.core_form_templates
        this.totalcount = res.core_form_templates_aggregate.aggregate.count
      } catch (err) {
        alert('Unable to fetch form templates')
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    closePreview () {
      this.selectedTemplate = {
        id: 0,
        open: false,
        loading: false,
        data: [],
        name: '',
        type: '',
        version: 0
      }
    },
    getFullName (user) {
      return `${user.first_name} ${user.last_name}`
    },
    openPreview (id) {
      this.selectedTemplate.loading = true
      this.selectedTemplate.id = id
      this.selectedTemplate.open = true
      getDetailFormTemplate(id).then((res) => {
        const template = res.core_form_templates_by_pk
        this.selectedTemplate.name = template.name
        this.selectedTemplate.type = template.core_form_type.name
        this.selectedTemplate.data = template.template_versions.map((item) => ({
          id: item.id,
          version_id: item.version_id,
          active: item.active,
          template_fields: item.template_fields.map((field) => ({
            ...field,
            key: field.form_field.key
          }))
        }))
        this.selectedTemplate.version =
            template.template_versions?.find((item) => item.active)?.id ?? 0
        this.selectedTemplate.loading = false
      })
    },
    enableWorkflowLink () {
      this.templates = this.templates.map((item) => ({
        ...item,
        workFlowLinkTemp: { flag: null, ...item.workflow_template }
      }))
      this.getTemplatesForWFL()
      this.workflowLinkEdit = true
    },
    async getTemplatesForWFL () {
      try {
        this.WFTLoading = true
        const res2 = await getFullWorkFLowTemplates([this.Config.CORE_FEATURES.FORMS, this.Config.CORE_FEATURES.DOCUMENTS])
        this.workflowTempaltes = res2.workflow_templates
        this.WFTLoading = false
      } catch (error) {
        alert('Error fetching  form templates')
        console.error('Error fetching templates', error)
      }
    },
    handleWrokflowSelection (item, formTemp, index) {
      if ((item.id === formTemp.workflow_template?.id) && item.id) {
        formTemp.workFlowLinkTemp = { flag: null, id: item.id ?? -1, name: item.name ?? null }
        this.$set(this.templates, index, formTemp)
        return
      }
      formTemp.workFlowLinkTemp = { flag: item ? 'update' : null, id: item.id ?? -1, name: item.name ?? null }
      this.$set(this.templates, index, formTemp)
    },
    async linkWorkFlow () {
      this.loading = true
      const updatesObjList = []

      for (const item of this.templates) {
        if (item.workFlowLinkTemp.id === -1 || !item.workFlowLinkTemp.id) {
          item.workFlowLinkTemp.id = null
        }
        if (item.workFlowLinkTemp.flag === 'update') {
          updatesObjList.push({
            _set: {
              workflow_template_id: item.workFlowLinkTemp.id
            },
            where: {
              id: {
                _eq: item.id
              }
            }

          })
        }
      }
      if (updatesObjList.length === 0) {
        this.loading = false
        alert('No changes made')
        return
      } else {
        try {
          await formWorkFlowLinkingApi(updatesObjList)
          success('Workflow templates linked successfully')
        } catch (error) {
          console.log(error)
          alert('Error linking workflow templates')
          this.loading = false
          return
        }
      }
      this.workflowLinkEdit = false
      this.getTemplates()
    },
    selectPage (page) {
      this.pageNumber = page
      this.getTemplates()
    }
    // handleSearchInput (el) {
    //   this.WFTSearchKeyword = el.target.value
    // }
  },
  watch: {
    selectedSort (value) {
      if (value === '0') return 0
      else return this.getTemplates()
    }
  },
  created () {
    if (
      !previousPath.includes('/copy-forms') &&
      !previousPath.includes('/form-editor')
    ) {
      this.$store.dispatch('form/removeSearchKeyword')
    }
    this.searchKeyword = this.searchKeywordStore
    this.updateOnSearch = debounce(() => {
      this.pageNumber = 1
      this.getTemplates()
    }, 500)
    this.getTemplates()
  }
}
</script>

<style lang="scss" scoped >
  .form-template-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
  min-width: 0;
}
  .audit-cell {
    white-space: normal !important;
    line-height: 1.2;
  }
  .audit-name,
  .audit-date {
   display: block;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
  }
  .audit-name {
   font-size: var(--text-xs2);
   font-weight: 400;
   color: #111827;
  }
  .audit-date {
   margin-top: 4px;
   font-size: var(--text-xs);
   color: #6b7280;
  }
  .close-btn {
  background: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 6px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--text-3xl);
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #e5e7eb;
    color: #374151;
  }
}
.sort {
  height: 2em;
  width: 10rem;
  margin: 0 5px 0 5px;
  font-size: var(--text-base);
  background-color: var(--brand-light-color);
  line-height: 1;
  border: 1px solid var(--brand-color);
  border-radius: 4px;
  padding: 4px 12px;
}

.form-template {
  &-table {
    height: calc(100% - 60px);
  }

  &-container {
    height: calc(100% - 60px);

    &-wft {
      &-search-box {
        padding: 5px 10px;
        background: white;
        position: sticky;
        top: 0;
        z-index: 10;
      }

      &-input {
        width: 100%;
        padding: 5px 10px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.3);
        background-color: transparent;
      }
    }
  }

  &-no-form {
    font-size: var(--text-2xl);
    color: var(--text-color);
  }

  &-group {
    overflow: auto;
    position: relative;

    & > div {
      & > div {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        & > div {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }

    &-header {
      background-color: var(--brand-color);
      position: sticky;
      top: 0;

      &-item {
        padding: 4px 10px;
        font-size: var(--text-base);
        font-weight: 600;
        color: var(--text-color);
      }
    }

    &-row {
      display: grid;
      grid-template-columns: 2fr 3fr 1fr 1fr 80px;
    }

    &-item {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      & > div {
        padding: 4px 10px;
        font-size: var(--text-base);
        color: var(--text-color);
      }
    }
  }

  &-preview {
    border-left: 1px solid #e5e7eb;
    background: #f8f9fa;

    &-header {
      padding: 12px 16px;
      background: #ffffff;
      border: 1px solid #e5e7eb;
      border-radius: 8px 8px 0 0;
      &-left {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;
        min-width: 0;
        max-width: 65%;
      }
      & > div:first-child {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      & > h3 {
        font-size: var(--text-xl);
        font-weight: 600;
        color: #1a1a1a;
        margin: 0;
      }

      & select {
        font-size: var(--text-xs1);
        background-color: #ffffff;
        line-height: 1;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        padding: 6px 2px;
        color: #374151;
      }
    }

    &-subtitle {
      font-size: var(--text-s);
      font-weight: 400;
      color: #6b7280;
      margin-top: 4px;
    }

    &-body {
      height: calc(100% - 70px);
      padding: 0;
      background: #f8f9fa;
      overflow-y: auto;
    }
  }
}

.form-template-split-view {
  display: grid;
  grid-template-columns: 55% 45%;
  gap: 0;
  overflow: hidden;

  > div:first-child {
    overflow-x: hidden;
  }

  > div:last-child {
    overflow: hidden;
  }
}
  .status {
    font-size: var(--text-m);
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    height: fit-content;
    padding: 3px 4px;
    border-radius: 3px;
    &-preview {
      flex-shrink: 0;
      background-color: #e3f2fd; /* Light blue */
      color: #1976d2; /* Blue */
}
  }
  .slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-right-enter {
  transform: translateX(100%);
  opacity: 0;
}

.slide-right-enter-to {
  transform: translateX(0);
  opacity: 1;
}

.slide-right-leave {
  transform: translateX(0);
  opacity: 1;
}

.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
